import React, { useRef, useEffect } from 'react';
import Modal from 'cccisd-modal';
import { useParams } from 'cccisd-react-router';
import axios from 'cccisd-axios';
import PropTypes from 'prop-types';
import Tooltip from 'cccisd-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import notification from 'cccisd-notification';
import GroupForm from '../../../../components/Manage/GroupForm';

import { getProducts } from '../../../../reducers/products';

import IconPencil from 'cccisd-icons/pencil';

const Boilerplate = window.cccisd && window.cccisd.boilerplate;
const Fortress = window.cccisd && window.cccisd.fortress;
const userRole = Fortress.user.acting.role.handle;
const isUberAdmin = userRole === 'uberadmin';

const EditGroupForm = props => {
    const { productHandle } = useParams();
    const modal = useRef();
    const dispatch = useDispatch();

    !isUberAdmin &&
        useEffect(() => {
            (async () => {
                dispatch(getProducts(productHandle));
            })();
        }, [dispatch]);

    const { productId } = useSelector(state => state.app.products);

    // rows are coming from each role's class_tableMain.graphql
    const { row, loadData } = props;

    const onSubmit = async values => {
        const response = await axios.put(
            Boilerplate.route('api.nexus.pawn.update', {
                pawn: row['pawn.pawnId'],
            }),
            {
                pawnHash: row['pawn.pawnHash'],
                productId: isUberAdmin ? values.productId : productId,
                groupLabel: values.groupLabel,
                group: values.school,
                parentPawns: values.groupLeaderIds,
                childPawns: values.participantIds,
            }
        );

        if (response.data.errors) {
            return Promise.reject(response.data.errors);
        }
        await loadData();
        notification('Group edited.');
        await modal.current.close();
    };

    const getPawnIds = list => {
        return list && list.length > 0
            ? list.map(l => {
                  return l.pawn.pawnId;
              })
            : [];
    };

    const getGroupLeaderOptions = list => {
        return list.length > 0
            ? list.map(l => {
                  return { value: l.pawn.pawnId, label: l.user.fullNameWithUsername };
              })
            : [];
    };

    return (
        <Modal
            ref={modal}
            trigger={
                <Tooltip title="Edit">
                    <button type="button" className="btn btn-xs btn-success">
                        <IconPencil />
                    </button>
                </Tooltip>
            }
            title={`Edit ${row['fields.groupLabel']}`}
        >
            <GroupForm
                operation="edit"
                onSubmit={onSubmit}
                initialValues={{
                    productId: row['fields.productId'],
                    groupLabel: row['fields.groupLabel'],
                    school: row['ancestorGroups.site.group.groupId'],
                    groupLeaders: getGroupLeaderOptions(row['parentRoles.instructorList']),
                    learners: getPawnIds(row['descendantRoles.learnerList']),
                }}
                {...props}
                productId={productId}
            />
        </Modal>
    );
};

EditGroupForm.propTypes = {
    loadData: PropTypes.func,
    row: PropTypes.object,
};

export default EditGroupForm;
